<template>
  <BittsEmptyState
    class="api-tab-empty-state"
    :title="title"
    :font-awesome-icon="icon"
  >
    <template #subtitle>
      <p class="api-tab-empty-state__description">
        {{ description }}
      </p>
      <div class="api-tab-empty-state__actions">
        <BittsTooltip placement="bottom">
          <BittsButton
            :text="createCtaText"
            :left-icon="['fak', 'add']"
            :disabled="!!createDisabledReason"
            @click="handleCreateClick"
          />
          <template v-if="createDisabledReason" #title>
            {{ createDisabledReason }}
          </template>
        </BittsTooltip>
        <BittsButton
          text="API docs"
          type="neutral"
          :right-icon="['fak', 'external-link']"
          @click="handleDocsClick"
        />
      </div>
    </template>
  </BittsEmptyState>
</template>

<script setup lang="ts">
import { BittsButton, BittsEmptyState, BittsTooltip } from '@crossbeam/bitts';
import type { BittsIcon } from '@crossbeam/bitts';
import { EVENT_SITES } from '@crossbeam/itly';

import { API_DOCS_URL } from '../constants';
import type { ApiTabValueType } from '../types';
import useApiControlsTracking from '../useApiControlsTracking';
import useApiRoutes from '../useApiRoutes';

const { tab, createDisabledReason = '' } = defineProps<{
  tab: ApiTabValueType;
  title: string;
  description: string;
  createCtaText: string;
  icon: BittsIcon;
  createDisabledReason?: string;
}>();

const { openCreate } = useApiRoutes();
const { trackCreateClicked } = useApiControlsTracking();

function handleCreateClick() {
  trackCreateClicked(tab, EVENT_SITES.API_TAB_EMPTY_STATE);
  openCreate(tab);
}

function handleDocsClick() {
  window.open(API_DOCS_URL, '_blank', 'noopener');
}
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";

.api-tab-empty-state {
  @apply flex-1;
}

.api-tab-empty-state__description {
  @apply text-neutral-text m-0 max-w-[420px];
}

.api-tab-empty-state__actions {
  @apply flex items-center justify-center gap-12 mt-24;
}
</style>
